import type { CmsApiFormBuilderBlockData } from '#/modules/cms/api/types/blocks/CmsApiFormBuilderBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsFormBuilderBlockMapping: CmsBlockMapping<CmsApiFormBuilderBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsFormBuilderBlock').then((m) => ({
          default: m.CmsFormBuilderBlock,
        })),
      { strategy: 'always' },
    ),
  };
